import { render, staticRenderFns } from "./VerifyInfo.vue?vue&type=template&id=36d39881&scoped=true"
import script from "./VerifyInfo.vue?vue&type=script&lang=js"
export * from "./VerifyInfo.vue?vue&type=script&lang=js"
import style0 from "./VerifyInfo.vue?vue&type=style&index=0&id=36d39881&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d39881",
  null
  
)

export default component.exports